import { Navigate } from 'react-router-dom';
import Help from '../pages/Help';
import Map from '../pages/Map';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import TermsOfService from '../pages/TermsOfService';
import CookiePolicy from '../pages/CookiePolicy';

import LayoutBasic from '../layouts/LayoutBasic';
import LayoutMap from '../layouts/LayoutMap';

const routesClient = [
  {
    path: '/',
    component: () => <Navigate to="/map" replace />,
    layout: LayoutBasic,
  },
  {
    path: '/help',
    component: Help,
    layout: LayoutBasic,
  },
  {
    path: '/map',
    component: Map,
    layout: LayoutMap,
  },
  {
    path: '/map/route/:routeId',
    component: Map,
    layout: LayoutMap,
  },
  {
    path: '/politica-de-privacidad',
    component: PrivacyPolicy,
    layout: LayoutBasic,
  },
  {
    path: '/privacidad',
    component: PrivacyPolicy,
    layout: LayoutBasic,
  },
  {
    path: '/condiciones-de-uso',
    component: TermsOfService,
    layout: LayoutBasic,
  },
  {
    path: '/terminos',
    component: TermsOfService,
    layout: LayoutBasic,
  },
  {
    path: '/politica-de-cookies',
    component: CookiePolicy,
    layout: LayoutBasic,
  },
  {
    path: '/cookies',
    component: CookiePolicy,
    layout: LayoutBasic,
  },
];

const routes = [
  ...routesClient,
  {
    path: '*',
    layout: LayoutBasic,
    component: () => <Navigate to="/map" replace />,
  },
];

export default routes;
